import Deposit from '@/components/common/Deposit.vue';
import Withdraw from '@/components/common/Withdraw.vue';
import Transfer from '@/components/common/Transfer.vue';
import Fiat from '@/components/common/Fiat.vue';
import DynamicsFiatModal from '@/components/channel-specific/dynamics/fiatModal';
import DynamicsWithdrawModal from '@/components/channel-specific/dynamics/withdrawModal';
import Config from '@/utils/Config';

import {
    mapState,
} from 'vuex';

export default {
    name: 'Dialog',
    props: {
        status: {
            type: String,
            default: 'withdraw',
        },
        title: [String, Boolean],
        address: {
            type: String,
            default: '',
        },
        withdrawMini: {
            type: String,
            default: '',
        },
        depositMini: {
            type: String,
            default: '',
        },
        chainType: {
            type: Number,
            default: 0,
        },
        warning: {
            type: Array,
            default: () => [],
        },
        currTarget: {
            type: Object,
            default: () => {},
        },
        balance: {
            type: Number,
            default: 0,
        },
        availableBtt: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            tempHide: false,
            Config,
        };
    },
    components: {
        Deposit,
        Withdraw,
        Transfer,
        Fiat,
        DynamicsFiatModal,
        DynamicsWithdrawModal,
    },
    computed: {
        ...mapState({
            storeConfirmStatus: state => state.confirmStatus,
            confirmStatus: state => state.confirmStatus,
        }),
    },
    mounted() {
        //  this.nowarning();
    },
    methods: {
        tempHideDialog(e) {
            const self = this;
            if (e === 'close') {
                self.tempHide = true;
            } else {
                self.tempHide = false;
            }
        },
        closeDialog() {
            const self = this;
            self.$emit('hideDialog', 'hideDialog');
        },
        withdrawhidden() {
            this.closeDialog();
        },
        fiathidden() {
            this.closeDialog();
        },
    },
};



// WEBPACK FOOTER //
// ./src/components/common/dialog.js